import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let connection = useDataValue({
    viewPath: props.viewPath,
    context: 'connection',
  })

  let { id: connection_id, app_id } = connection ?? {}

  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })
  return {
    variables: {
      app_id,
      location_id,
      connection_id,
    },
    pause: false,
  }
}
